import React from 'react';
import MUIAlert, { AlertProps } from '@mui/material/Alert';
import MUIAlertTitle, { AlertTitleProps } from '@mui/material/AlertTitle';

export const MuiAlert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
	return <MUIAlert ref={ref} {...props} />;
});

export const MuiAlertTitle = (props: AlertTitleProps) => {
	return <MUIAlertTitle {...props}>{props.children}</MUIAlertTitle>;
};
